import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ScEndpointFilter, ScFieldConfig } from '../../../../models/table.model';

@Component({
  selector: 'sc-table-view-filters',
  templateUrl: './sc-table-view-filters.component.html',
  styleUrls: ['./sc-table-view-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScTableViewFiltersComponent implements OnInit {
  @Input() totalAdvancedFilters: number;
  @Output() openAdvancedFilters: EventEmitter<any> = new EventEmitter();
  @Output() filterChange: EventEmitter<ScEndpointFilter[]> = new EventEmitter();
  public form = new FormGroup({});
  private _filtersActive = 'close';
  private _fields: any[] = [];
  private _filters: any[] = [];

  @Input() set filters(filters: any[]) {
    this._filters = filters;
    filters.forEach(filter => {
      this._fields = [...this.fields, filter.field];
    });
  }

  get filters() {
    return this._filters;
  }

  @Input() set value(value: any) {
    if (value) {
      this.form.patchValue(value);
    }
  }

  get fields(): ScFieldConfig[] {
    return this._fields;
  }

  @Input() set isActive(isActive) {
    this._filtersActive = isActive ? 'open' : 'close';
  }

  get isActive(): string {
    return this._filtersActive;
  }

  ngOnInit() {}

  searchResult(data: any) {
    const filters: any[] = Object.keys(data)
      .map(key => {
        const { filter } = this._filters.find(f => f.field.key === key);
        return {
          ...filter,
          value: data[key]
        };
      })
      .filter(filter => filter.value);

    this.filterChange.emit(filters);
  }
}
